import { Wallet } from "lucide-react";
import FinancePage from "@/components/FinancePage";

const CATEGORIES = ["Internet", "Server", "Listrik", "Maintenance", "Gaji", "Peralatan", "Operasional", "Lainnya"];

const Expenses = () => (
  <FinancePage
    title="Pengeluaran"
    subtitle="Catat biaya operasional dan pengeluaran usaha"
    endpoint="/expenses"
    categories={CATEGORIES}
    icon={Wallet}
    accent="danger"
    totalLabel="Total Pengeluaran"
  />
);

export default Expenses;
